import { SelectedNodes } from '../types';

const getDivisionName = (selectedNodes: SelectedNodes): string => {
  const division = selectedNodes.find(
    ({ type }: { type: string }) =>
      type === 'division' || type === 'sub-division'
  );
  return division ? division.name : '';
};

export default ({
  brandName,
  abbrNameForTealium,
  selectedNodes,
}: {
  brandName: string;
  abbrNameForTealium: string;
  selectedNodes: SelectedNodes;
}): string => {
  const divisionName = getDivisionName(selectedNodes);

  return brandName === 'gapfs'
    ? `${brandName}:${divisionName}`
    : `${abbrNameForTealium}:${divisionName}`;
};
